import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/invitationEmpty.png'
import _imports_1 from '../../../../assets/icons/warning-red-icon.svg'


const _withScopeId = n => (_pushScopeId("data-v-b8f7936e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "tw-flex tw-flex-col tw-justify-center tw-items-center tw-w-full tw-h-[70vh]"
}
const _hoisted_2 = {
  key: 1,
  class: "invitation_list__wrapper"
}
const _hoisted_3 = {
  key: 0,
  class: "title"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "invitation_list__title" }, "Invitations", -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { class: "text-left" }
const _hoisted_7 = { class: "text-center" }
const _hoisted_8 = { class: "text-center" }
const _hoisted_9 = { class: "text-center" }
const _hoisted_10 = { class: "text-left" }
const _hoisted_11 = { class: "tw-flex tw-items-center tw-gap-2" }
const _hoisted_12 = { class: "tw-rounded-full tw-overflow-hidden tw-h-[30px] tw-w-[30px] tw-relative tw-max-w-full tw-max-h-full" }
const _hoisted_13 = { class: "text-center" }
const _hoisted_14 = { class: "text-center" }
const _hoisted_15 = { class: "text-center tw-text-[#FFA500]" }
const _hoisted_16 = {
  key: 2,
  class: "invitation_list__content mobile__wrapper"
}
const _hoisted_17 = { class: "member_name" }
const _hoisted_18 = { class: "tw-rounded-full tw-overflow-hidden tw-h-[30px] tw-w-[30px] tw-relative tw-max-w-full tw-max-h-full" }
const _hoisted_19 = { class: "member_card__content" }
const _hoisted_20 = { class: "content_list_item" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Role", -1))
const _hoisted_22 = { class: "tw-capitalize" }
const _hoisted_23 = { class: "content_list_item" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "INVITED DATE", -1))
const _hoisted_25 = { style: {"text-transform":"capitalize"} }
const _hoisted_26 = { class: "manage_card_footer" }
const _hoisted_27 = {
  key: 3,
  class: "empty-screen"
}
const _hoisted_28 = { class: "empty-screen__inner" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "empty-screen__image" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: ""
  })
], -1))
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "empty-screen__header" }, [
  /*#__PURE__*/_createElementVNode("h2", null, "You haven't sent any invitations yet."),
  /*#__PURE__*/_createElementVNode("p", null, " Start inviting team members now to collaborate more effectively on your workstation! ")
], -1))
const _hoisted_31 = { class: "empty-screen__footer" }
const _hoisted_32 = { class: "modal__content" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal__content_img" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_1 })
], -1))
const _hoisted_34 = { class: "modal__content_header" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Cancel Invitation?", -1))
const _hoisted_36 = { class: "modal__footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Loader = _resolveComponent("Loader")!
  const _component_Text = _resolveComponent("Text")!
  const _component_UserProfileLogo = _resolveComponent("UserProfileLogo")!
  const _component_v_table = _resolveComponent("v-table")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_CommonDialog = _resolveComponent("CommonDialog")!
  const _component_AddTeamMemberModal = _resolveComponent("AddTeamMemberModal")!
  const _component_EditTeamMemberModal = _resolveComponent("EditTeamMemberModal")!
  const _component_PropertyOwnerSubscriptionModal = _resolveComponent("PropertyOwnerSubscriptionModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    ($setup.isLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_Loader, { show: $setup.isLoading }, null, 8, ["show"])
        ]))
      : _createCommentVNode("", true),
    (!$setup.isLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          ($setup.modifiedMembers?.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_5))
            : _createCommentVNode("", true),
          ($setup.modifiedMembers?.length)
            ? (_openBlock(), _createBlock(_component_v_table, {
                key: 1,
                class: "tw-pt-8 tw-pb-4 tw-box-border tw-bg-transparent desktop__wrapper"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("thead", null, [
                    _createElementVNode("tr", null, [
                      _createElementVNode("th", _hoisted_6, [
                        _createVNode(_component_Text, { variant: "p" }, {
                          default: _withCtx(() => [
                            _createTextVNode("Email ID")
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("th", _hoisted_7, [
                        _createVNode(_component_Text, {
                          variant: "p",
                          whiteSpace: "nowrap"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("ROLE")
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("th", _hoisted_8, [
                        _createVNode(_component_Text, {
                          variant: "p",
                          whiteSpace: "nowrap"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Invited Date")
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("th", _hoisted_9, [
                        _createVNode(_component_Text, {
                          variant: "p",
                          whiteSpace: "nowrap"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Action")
                          ]),
                          _: 1
                        })
                      ])
                    ])
                  ]),
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.modifiedMembers, (member, index) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: index,
                        class: "tw-cursor-pointer"
                      }, [
                        _createElementVNode("td", _hoisted_10, [
                          _createElementVNode("div", _hoisted_11, [
                            _createElementVNode("div", _hoisted_12, [
                              _createVNode(_component_UserProfileLogo, {
                                color: member?.color,
                                userName: member?.email
                              }, null, 8, ["color", "userName"])
                            ]),
                            _createVNode(_component_Text, {
                              class: "tw-whitespace-nowrap",
                              variant: "p"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(member?.email), 1)
                              ]),
                              _: 2
                            }, 1024)
                          ])
                        ]),
                        _createElementVNode("td", _hoisted_13, [
                          _createVNode(_component_Text, {
                            class: "tw-whitespace-nowrap tw-capitalize",
                            variant: "p"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(member?.role), 1)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _createElementVNode("td", _hoisted_14, [
                          _createVNode(_component_Text, {
                            class: "tw-whitespace-nowrap",
                            variant: "p"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(member?.dateCreated ? $setup.formatDate(member?.dateCreated) : "--"), 1)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _createElementVNode("td", _hoisted_15, [
                          _createElementVNode("div", null, [
                            _createVNode(_component_Text, {
                              onClick: ($event: any) => ($setup.onClickRemoveTeamMember(member?.id, member)),
                              class: "tw-whitespace-nowrap",
                              variant: "p"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("cancel")
                              ]),
                              _: 2
                            }, 1032, ["onClick"])
                          ])
                        ])
                      ]))
                    }), 128))
                  ])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          ($setup.modifiedMembers?.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.modifiedMembers, (member, index) => {
                  return (_openBlock(), _createBlock(_component_v_card, {
                    class: "invitation_list__card",
                    key: index
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_17, [
                        _createElementVNode("div", _hoisted_18, [
                          _createVNode(_component_UserProfileLogo, {
                            color: member?.color,
                            userName: member?.email
                          }, null, 8, ["color", "userName"])
                        ]),
                        _createVNode(_component_Text, {
                          class: "tw-whitespace-nowrap",
                          variant: "p"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(member?.email), 1)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _createElementVNode("div", _hoisted_19, [
                        _createElementVNode("div", _hoisted_20, [
                          _hoisted_21,
                          _createElementVNode("p", _hoisted_22, _toDisplayString(member?.role), 1)
                        ]),
                        _createElementVNode("div", _hoisted_23, [
                          _hoisted_24,
                          _createElementVNode("p", _hoisted_25, _toDisplayString(member?.dateCreated ? $setup.formatDate(member?.dateCreated) : "--"), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_26, [
                        _createVNode(_component_v_btn, {
                          onClick: ($event: any) => ($setup.onClickRemoveTeamMember(member?.id, member)),
                          class: "button button-purple-border",
                          "max-width": "100%"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("CANCEL INVITATION")
                          ]),
                          _: 2
                        }, 1032, ["onClick"])
                      ])
                    ]),
                    _: 2
                  }, 1024))
                }), 128))
              ]))
            : _createCommentVNode("", true),
          (!$setup.modifiedMembers?.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                _createElementVNode("div", _hoisted_28, [
                  _hoisted_29,
                  _hoisted_30,
                  _createElementVNode("div", _hoisted_31, [
                    _createVNode(_component_v_btn, {
                      class: "button button-purple",
                      onClick: $setup.onClickAddTeamMember,
                      block: ""
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Add New Member ")
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          ($setup.isShowRemoveTeamMemberModal)
            ? (_openBlock(), _createBlock(_component_CommonDialog, {
                key: 4,
                isShowHeader: false,
                onClickBackButton: $setup.onClickBackButton,
                className: ['remove_invitation_dialog'],
                width: "350px"
              }, {
                body: _withCtx(() => [
                  _createElementVNode("div", _hoisted_32, [
                    _hoisted_33,
                    _createElementVNode("div", _hoisted_34, [
                      _hoisted_35,
                      _createElementVNode("p", null, [
                        _createTextVNode(" Are you sure you want to cancel "),
                        _createElementVNode("span", null, _toDisplayString($setup.memberName) + "'s", 1),
                        _createTextVNode(" invitation to iknowa platfrom? ")
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_36, [
                    _createVNode(_component_v_btn, {
                      class: "button button-purple-border",
                      onClick: $setup.onClickBackButton
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Cancel")
                      ]),
                      _: 1
                    }, 8, ["onClick"]),
                    _createVNode(_component_v_btn, {
                      class: "button button-orange",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.onClickConfirmRemoveTeamMember($setup.userMemberId)))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("CONFIRM")
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _: 1
              }, 8, ["onClickBackButton"]))
            : _createCommentVNode("", true),
          ($setup.openedModel === $setup.modelName.ADDTEAMMEMBER)
            ? (_openBlock(), _createBlock(_component_AddTeamMemberModal, {
                key: 5,
                onOnClickCloseTab: $setup.onClickCloseModel
              }, null, 8, ["onOnClickCloseTab"]))
            : _createCommentVNode("", true),
          ($setup.openedModel === $setup.modelName.EDITTEAMMEMBER)
            ? (_openBlock(), _createBlock(_component_EditTeamMemberModal, {
                key: 6,
                memberData: $setup.memberData,
                onOnClickCloseTab: $setup.onClickCloseModel
              }, null, 8, ["memberData", "onOnClickCloseTab"]))
            : _createCommentVNode("", true),
          ($setup.isShowUpgradePremiumModal)
            ? (_openBlock(), _createBlock(_component_PropertyOwnerSubscriptionModal, {
                key: 7,
                onCloseSubscriptionModal: $setup.closeUpgradePremiumModal,
                onCloseSelectWorkstationTypeModal: $setup.closeUpgradePremiumModal
              }, null, 8, ["onCloseSubscriptionModal", "onCloseSelectWorkstationTypeModal"]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ], 64))
}